export const threeDots = `<svg width="40" height="10" viewBox="0 0 40 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="5" cy="5" r="5" fill="#33E2FF"/>
<circle cx="20" cy="5" r="5" fill="#33E2FF"/>
<circle cx="35" cy="5" r="5" fill="#33E2FF"/>
</svg>
`;
